module.exports = __webpack_public_path__ + "img/portrait-068.8f9d53ba.jpg";